import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useExternalTypeId from '../../../hooks/useExternalTypeId';
import { RootState } from '../../../store/rootStore';
import FontsTable from '../components/FontsTable';
import { deleteFont, getFonts } from '../store/settings.store';

const FontsTableContainer: React.FC = () => {
  const dispatch = useDispatch<any>();
  const { externalType, externalId, isLoaded, hasExternalId } = useExternalTypeId();

  const fonts = useSelector((state: RootState) => state.settings.fonts.data);
  const handleDelete = React.useCallback(
    (fontId: string) => {
      if (!hasExternalId) {
        return;
      }
      dispatch(deleteFont({ fontId, externalId, externalType }));
    },
    [dispatch, externalType, externalId, hasExternalId]
  );
  React.useEffect(() => {
    if (isLoaded && hasExternalId) {
      dispatch(getFonts({ externalId, externalType }));
    }
  }, [dispatch, isLoaded, hasExternalId, externalType, externalId]);

  return (
    <>
      <FontsTable fonts={fonts || []} onDelete={handleDelete} />
    </>
  );
};
export default FontsTableContainer;
